<template>
  <div>
    <video ref="videoPlayer" class="video-js h-100"></video>
  </div>
</template>

<script>
import videojs from 'video.js';
export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: ()=>({

  }),
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
}
</script>

<style scoped>

</style>
